import { useBasket } from '@/src/packages/components/contexts/basket.context';
import { useProductContext } from '@/src/packages/components/pages/Product/ProductContext';
import { Box } from '@/src/packages/components/ui/Box';
import { Button } from '@/src/packages/components/ui/Button';
import { Carousel } from '@/src/packages/components/ui/Carousel';
import { Container } from '@/src/packages/components/ui/Container';
import { Divider } from '@/src/packages/components/ui/Divider';
import { ProductCard } from '@/src/packages/components/ui/ProductCard';
import { Sheet, SheetContent } from '@/src/packages/components/ui/Sheet';
import { paths } from '@/src/packages/routes';
import { pathParams } from '@/src/packages/routes/pathParams.enum';
import { getRoute } from '@/src/packages/utils/routes';
import { useDisclosure } from '@bitmap/utils/hooks/use-disclosure';
import Link from 'next/link';
import { useEffect, useRef } from 'react';
import { SwiperSlide } from 'swiper/react';

export const ProductUpsellingModal = () => {
  const {
    productVariant: { completeTheLook },
  } = useProductContext();

  const { isOpen, onOpen, onToggle, onClose } = useDisclosure();

  const { basket, isUpdating } = useBasket();

  const firstUpdate = useRef(true);

  useEffect(() => {
    // if (firstUpdate.current) {
    //   firstUpdate.current = false;
    //   return;
    // }

    // if (!isUpdating && completeTheLook.length > 0) {
    //   onOpen();
    // }
  }, [isUpdating]);

  if (isOpen && basket) {
    return (
      <Sheet open={true} onOpenChange={onClose}>
        <SheetContent side="bottom" className="bg-[#282828] h-auto">
          <Box className="w-full bg-[#282828]">
            <Container className="max-w-[1000px] py-4 flex items-center">
              Added to bag
            </Container>
          </Box>
          <Container className="max-w-[1000px] py-6">
            <Box className="flex flex-col gap-2 ml-auto">
              <Link
                href={getRoute({
                  route: paths.CHECKOUT_INDEX,
                  params: { [pathParams.CHECKOUT]: basket?.uuid },
                })}
                className="block"
              >
                <Button color="black" variant="solid" size="lg" isBlock>
                  Checkout
                </Button>
              </Link>
              <Button color="white" size="lg" onClick={() => {}}>
                Continue shopping
              </Button>
            </Box>

            <Divider className="my-5" />
            <Box className="overflow-hidden w-full space-y-4">
              <Box className="text-xl">Complete the look</Box>

              <Carousel
                isFlush
                slidesPerView={2.2}
                breakpoints={{
                  800: { slidesPerView: 3 },
                }}
              >
                {completeTheLook.map((product, i) => {
                  return (
                    <SwiperSlide key={i}>
                      <ProductCard productVariant={product} />
                    </SwiperSlide>
                  );
                })}
              </Carousel>
            </Box>
          </Container>
        </SheetContent>
      </Sheet>
    );
  }
  return <></>;
};
